import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Rentals',
    path: '/rentals'
  }, {
    name: 'Gallery',
    path: '/gallery'
  }, {
    name: 'Industries',
    path: '/industries'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-charcoal/90 backdrop-blur-md shadow-lg py-4' : 'bg-transparent py-6'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-91">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/nxk8PbTo7ETLYk7nrXHatr/Audiotech_logo_(Bags).png" alt="Audiotech Logo" className="h-12 w-auto object-contain" data-id="element-93" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-94">
          <ul className="flex items-center gap-6" data-id="element-95">
            {navLinks.map(link => <li key={link.name} data-id="element-96">
                <Link to={link.path} className={`text-sm font-medium transition-colors hover:text-brand-blue ${location.pathname === link.path ? 'text-brand-blue' : 'text-brand-muted-light'}`} data-id="element-97">
                  {link.name}
                </Link>
              </li>)}
          </ul>
          <div className="flex items-center gap-4 border-l border-white/10 pl-6" data-id="element-98">
            <a href="tel:+2673928692" className="text-brand-muted-light hover:text-brand-blue transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-99">
              <PhoneIcon className="w-4 h-4" data-id="element-100" />
              Call Us
            </a>
            <Link to="/contact" className="btn-glow text-sm py-2 px-5" data-id="element-101">
              Request a Quote
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-102">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-103" /> : <MenuIcon className="w-6 h-6" data-id="element-104" />}
        </button>
      </div>

      {/* Mobile Nav Drawer */}
      <div className={`fixed inset-0 bg-brand-black/95 backdrop-blur-xl z-40 lg:hidden transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
      top: '72px'
    }} data-id="element-105">
        <div className="flex flex-col h-full p-6 overflow-y-auto" data-id="element-106">
          <ul className="flex flex-col gap-6 mb-8" data-id="element-107">
            {navLinks.map(link => <li key={link.name} data-id="element-108">
                <Link to={link.path} className={`text-xl font-medium block ${location.pathname === link.path ? 'text-brand-blue' : 'text-white'}`} data-id="element-109">
                  {link.name}
                </Link>
              </li>)}
          </ul>
          <div className="mt-auto flex flex-col gap-4 pb-12" data-id="element-110">
            <a href="tel:+2673928692" className="btn-outline w-full justify-center" data-id="element-111">
              <PhoneIcon className="w-5 h-5 mr-2" data-id="element-112" />
              Call (+267) 3928692
            </a>
            <Link to="/contact" className="btn-glow w-full justify-center" data-id="element-113">
              Request a Quote
            </Link>
          </div>
        </div>
      </div>
    </header>;
}